module.exports = __webpack_public_path__ + "static/img/event-logo.e7fb97c7.svg";